// Package imports
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import find from "lodash/find";
import LeafCard from "../Card/LeafCard";
import Confirmation from "../Modal/Confirmation";
import TeachingModal from "../Modal/TeachingModal";
import { makeStyles } from "@material-ui/core/styles";

// Custom imports
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

// Global variables

// Component
const Leaf = (props) => {
  // Hooks
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { moduleId, id } = useParams();
  const classes = useStyles();

  // State
  const [sessionData, setSessionData] = useState(null);
  const [alertFlag, setAlertFlag] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [classModal, setClassModal] = useState(false);
  const [lastObj, setLastObj] = useState(null);
  const [lastInnerObj, setLastInnerObj] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const product = useSelector((state) => state.product.productData);
  const language = useSelector((state) => state.product.language);
  let coursePermissions = useSelector(
    (state) => state.defs.siteConfig.products[0]["coursePermissions"]
  );
  const { breadcrumb } = useSelector((state) => state.common);

  // React logic hooks
  useEffect(() => {
    let module;
    let languageTitle;
    if (language > -1) {
      languageTitle = JSON.parse(product[0]["course_data"])["data"][0]["data"][
        language
      ]["value"];
      module = find(
        JSON.parse(product[0]["course_data"])["data"][0]["data"][language][
          "data"
        ],
        { id: moduleId }
      );
    } else {
      module = find(JSON.parse(product[0]["course_data"])["data"][0]["data"], {
        id: moduleId,
      });
    }
    let session = find(module.data, { id: id });
    console.log("session", session);
    if (session) {
      setSessionData(session);
    }
    if (languageTitle) {
      dispatch(
        commonSliceActions.setBreadcrumb(
          `${languageTitle} | ${module.value} | ${session.value}`
        )
      );
    } else {
      dispatch(
        commonSliceActions.setBreadcrumb(`${module.value} | ${session.value}`)
      );
    }
  }, [location, product]);

  // Route redirect function
  const redirect = (obj, innerObj) => {
    if (obj.data.length == 0) {
      setAlertFlag(true);
      return false;
    }

    if (location.pathname.includes("Teach")) {
      checkForSelfOrTeaching(obj, innerObj);
      //navigation(`/Teach/Leaf/${id}/${obj.id}`);
    } else if (location.pathname.includes("Task")) {
      if (location.pathname.includes("Create")) {
        navigation(
          `/Task/Create/Asset/${moduleId}/${id}/${innerObj.id}/${obj.id}`
        );
      } else {
        navigation(
          `/Task/Edit/Asset/${moduleId}/${id}/${innerObj.id}/${obj.id}`
        );
      }
    }

    // switch (route.name) {
    //   case "LeafList":
    //     checkForSelfOrTeaching(obj, innerObj);
    //     break;
    //   case "CreateTaskLeaf":
    //     navigation.navigate("Task", {
    //       screen: "CreateTaskAssetList",
    //       params: {
    //         moduleId: route.params.moduleId,
    //         sessionId: route.params.id,
    //         nodeId: innerObj.id,
    //         id: obj.id,
    //       },
    //     });
    //     break;
    // }
  };

  const checkForSelfOrTeaching = (obj, innerObj) => {
    if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      setConfirmModal(true);
      setLastObj(obj);
      setLastInnerObj(innerObj);
    } else {
      redirectToAssets(obj, innerObj);
      setLastObj(null);
      setLastInnerObj(null);
    }
  };

  const redirectToAssets = (obj, innerObj) => {
    setConfirmModal(false);
    dispatch(
      commonSliceActions.setBreadcrumb(
        `${breadcrumb} | ${innerObj.value} | ${obj.value}`
      )
    );
    navigation(`/Teach/Content/${moduleId}/${id}/${innerObj.id}/${obj.id}`);
  };

  // JSX template
  return (
    <Grid
      item
      xs={12}
       
      sx={{ overflow: "auto", height: "81vh" }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: location.pathname.includes("Teach")
            ? "space-around"
            : "flex-start",
          py: 3,
        }}
      >
        {sessionData &&
          sessionData.data
            .filter((val) => {
              return (
                coursePermissions && coursePermissions.indexOf(val.value) == -1
              );
            })
            .map((obj, index) => {
              return (
                <Grid item sx={{}} key={"leaf_" + index}>
                  <LeafCard
                    title={obj.value}
                    data={obj.data}
                    press={(innerObj) => {
                      redirect(innerObj, obj);
                    }}
                  />
                </Grid>
              );
            })}
      </Grid>
      <Confirmation
        visible={alertFlag}
        primaryText={"Assets not available"}
        image="error"
        alert={true}
        toggleModal={(flag) => setAlertFlag(flag)}
        timeout={2000}
      ></Confirmation>
      <Confirmation
        image="assign"
        primaryText="content for ?"
        visible={confirmModal}
        toggleModal={(flag) => setConfirmModal(flag)}
        positiveClick={() => {
          setConfirmModal(false);
          setClassModal(true);
        }}
        negativeClick={() => {
          dispatch(
            currentAssetSliceActions.setTrainerContinueTeachingClass("self")
          );
          dispatch(
            currentAssetSliceActions.setTrainerContinueTeachingClassName("Self")
          );
          redirectToAssets(lastObj, lastInnerObj);
        }}
        positiveText="Learning"
        negativeText="Review"
      ></Confirmation>
      <TeachingModal
        visible={classModal}
        toggleModal={(flag) => setClassModal(flag)}
        go={(selectedclass, selectedclassname) => {
          dispatch(
            currentAssetSliceActions.setTrainerContinueTeachingClass(
              selectedclass
            )
          );
          dispatch(
            currentAssetSliceActions.setTrainerContinueTeachingClassName(
              selectedclassname
            )
          );
          redirectToAssets(lastObj, lastInnerObj);
        }}
      ></TeachingModal>
    </Grid>
    // <ScrollView style={[Styles.mt1]}>
    //   <View style={{marginBottom: height * 0.02}}>
    //     {sessionData &&
    //       sessionData.data.map((obj, index) => {
    //         return (
    //           <View key={"leaf_" + index}>
    //             <Leafcard
    //               title={obj.value}
    //               data={obj.data}
    //               press={(innerObj) => {
    //                 redirect(innerObj, obj);
    //               }}
    //             />
    //           </View>
    //         );
    //       })}
    //   </View>
    //   <Confirmation
    //     visible={alertFlag}
    //     primaryText={"Assets not available"}
    //     image="error"
    //     alert={true}
    //     toggleModal={(flag) => setAlertFlag(flag)}
    //     timeout={2000}
    //   ></Confirmation>
    //   <Confirmation
    //     image="assign"
    //     primaryText="View the content for ?"
    //     visible={confirmModal}
    //     toggleModal={(flag) => setConfirmModal(flag)}
    //     positiveClick={() => {
    //       dispatch(currentAssetSliceActions.setTrainerContinueTeachingClass('self'));
    //       redirectToAssets(lastObj, lastInnerObj);
    //     }}
    //     negativeClick={() => {
    //       setConfirmModal(false);
    //       setClassModal(true);
    //     }}
    //     positiveText="Self review"
    //     negativeText="Teaching"
    //   ></Confirmation>
    //   <ClassSelection
    //     visible={classModal}
    //     title="Select Class"
    //     changeValue={(obj) => {
    //       dispatch(currentAssetSliceActions.setTrainerContinueTeachingClass(obj.id));
    //       redirectToAssets(lastObj, lastInnerObj);
    //     }}
    //     toggleModal={(flag) => setClassModal(flag)}
    //   ></ClassSelection>
    // </ScrollView>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default Leaf;
